<template>

  <div class="manage">
    <el-dialog
      :title="operateType === 'add' ? '新增数据类型' : '编辑数据类型'"
      :visible.sync="isShow"
    >
      <CommonForm
        :form-label="operateFormLabel"
        :form="operateForm"
      >
      </CommonForm>

      <span slot="footer" class="dialog-footer">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button @click="confirm">确 定</el-button>
      </span>

    </el-dialog>


    <!--数据表格-->
    <div class="manage-header">
      <el-row style="height: 0.18rem">
        <el-col :span="12">
          <div style="text-align: left">
            <el-button class="function-button1" icon="el-icon-plus" @click="addHandleDataType">新增</el-button>
            <el-button class="function-button2" icon="el-icon-edit" @click="editHandleDataType">编辑</el-button>
            <el-button class="function-button3" icon="el-icon-delete" @click="deleteHandleDataType">删除</el-button>
          </div>
        </el-col>
        <el-col :span="12">
          <CommonForm inline :form-label="formLabel" :form="searchFrom">
            <el-button class="search-button" @click="getHandleDataTypes">搜索</el-button>
            <el-button class="reset-button" @click="resetSearch">重置</el-button>
          </CommonForm>
        </el-col>
      </el-row>
    </div>

    <el-divider class="divideLine"></el-divider>

    <CommonTableSelect
      class="commonTable"
      :table-data="tableData"
      :table-label="tableLabel"
      :config="config"
      @changePage="getHandleDataTypes"
      @sizeChange="sizeChange"
      @currentChange="currentChange"
    >
    </CommonTableSelect>

  </div>


</template>
<style>
</style>
<script>
import CommonTableSelect from '../components/CommonTableSelect'
import CommonForm from '../components/CommonForm'
import Util from '../commonjs/util'
export default {
  name: 'HandleDataType',
  components: {
    CommonTableSelect,
    CommonForm
  },
  data() {
    return {
      isShow: false,
      searchFrom: {
        id: '',
        dataType: '',
        description: ''
      },
      //   dialog form
      operateForm: {
        id: '',
        dataType: '',
        description: ''
      },
      // dialog  formlabel
      operateFormLabel: [
        {
          model: 'dataType',
          label: '数据类型'
        },
        {
          model: 'description',
          label: '数据类型描述'
        }
      ],
      formLabel: [
        {
          model: 'dataType',
          label: '数据类型'
        },
        {
          model: 'description',
          label: '数据类型描述'
        }
      ],
      config: {
        sizes: [10, 20, 30],
        count: 0,
        limit: 10,
        page: 1,
        loading: true,
        showBar: false
      },
      tableData: [],
      tableLabel: [
        {
          prop: 'dataType',
          label: '数据类型',
          sortable: true
        },
        {
          prop: 'description',
          label: '描述'
        }
      ],
      operateType: 'add'
    }
  },
  created() {
    this.getHandleDataTypes()
  },
  methods: {
    open() {
      this.$confirm('确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    addHandleDataType() {
      this.operateType = 'add'
      this.isShow = true
      Util.cleaerObj(this.operateForm)
    },
    editHandleDataType() {
      if (this.canOperate()) {
        this.operateType = 'edit'
        this.isShow = true
      } else {
        this.$message({
          message: '还未选择要操作的数据',
          type: 'warning'
        })
      }
    },
    deleteHandleDataType() {
      if (this.canOperate()) {
        this.operateType = 'del'
        this.$confirm('确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.confirm()
        }).then(() => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      } else {
        this.$message({
          message: '还未选择要操作的数据',
          type: 'warning'
        })
      }
    },
    getHandleDataTypes() {
    },
    sizeChange(size) {
      this.config.limit = size
      this.getHandleDataTypes()
    },
    confirm() {
    },
    canOperate() {
      if (Util.isEmptyObj(this.operateForm)) return false
      else return true
    },
    resetSearch() {
      Util.cleaerObj(this.searchFrom)
      this.getHandleDataTypes()
    },
    currentChange(val) {
      Util.listAssign(this.operateForm, val)
    }
  }
}

</script>

<style lang="scss" scoped>
  @import "../scss/commonTableVue";
</style>
